import { Container, GridBreakpointsMediaDown, GridBreakpointsMediaUp } from '@dbi-tools/ui-kit';
import { Col as ColStyle } from '@dbi-tools/ui-kit/lib/components/grid/index';
import { IconStyled } from '@dbi-tools/ui-kit/lib/components/icon';
import { OptionImageTextStyled, OptionWrap } from '@dbi-tools/ui-kit/lib/options';
import styled from 'styled-components';

export const RowsContainerStyled = styled(Container)`
  @media (min-width: 1300px) {
    max-width: 1280px;
  }

  @media (min-width: 576px) and (max-width: 767px) {
    max-width: 500px;
  }

  @media (max-width: 575px) {
    padding-left: 20px;
    padding-right: 20px;
  }
`;

export const CardsContainerStyled = styled(Container)`
  @media (min-width: 1300px) {
    max-width: 1280px;
  }

  @media (max-width: 575px) {
    padding-left: 20px;
    padding-right: 20px;
  }
`;

export const PinterestContainerStyled = styled('div')`
  column-gap: 0;
  margin: 0 auto;
  padding: 0;
  width: 100%;

  ${GridBreakpointsMediaUp.md} {
    column-count: 4;
  }
  ${GridBreakpointsMediaDown.md} {
    column-count: 2;
  }

  @media (min-width: 1300px) {
    max-width: 1300px;
  }

  @media (min-width: 1200px) and (max-width: 1299px) {
    max-width: 1200px;
  }

  @media (min-width: 992px) and (max-width: 1199px) {
    max-width: 990px;
  }

  ${GridBreakpointsMediaDown.xs} {
    padding: 0 10px;
  }

  > ${OptionWrap} {
    width: 100%;
    display: inline-block;
    break-inside: avoid;
    padding: 0 10px 20px;
    overflow: hidden;
    transform: translate3d(0, 0, 0);
    position: relative;

    ${OptionImageTextStyled}, ${IconStyled} {
      transform: translate(-50%, -50%) translate3d(0, 0, 0);
    }

    .drag-active {
      background-color: #e8184c;
      position: absolute;
      opacity: 0.5;
      width: 100%;
      height: 100%;
    }

    .drag-handle {
      position: absolute;
      top: 5px;
      left: 15px;
      z-index: 2;
      background: #fff;
      padding: 5px;
      height: 22px;
      width: 26px;
      &::before {
        background-repeat: repeat;
        height: 12px;
        width: 16px;
      }
    }

    .drag-edit-button {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) translate3d(0, 0, 0);
      width: 80%;
    }
  }
`;

export const IconsContainerStyled = styled(Container)`
  margin: 0;

  @media (min-width: 401px) {
    ${ColStyle} {
      &:nth-of-type(3n + 1) {
        text-align: left;
      }

      &:nth-of-type(3n + 2) {
        text-align: center;
      }

      &:nth-of-type(3n) {
        text-align: right;
      }
    }
  }

  @media (max-width: 400px) {
    padding: 0 5px;

    ${ColStyle} {
      &:nth-of-type(2n) {
        text-align: right;
      }

      &:nth-of-type(2n + 1) {
        text-align: left;
      }
    }
  }
`;
